import React, { useCallback } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import {
  editTimecard,
  updateAutoClockOut,
} from 'features/timesheets/TimesheetsPage/TimecardModal/slices';

import { toI18n } from 'util/i18n';

import Issue from './Issue';

// eslint-disable-next-line no-shadow
const AutoClockOut = ({ issue, shift, updateAutoClockOut }) => {
  const dispatch = useDispatch();

  const handleEditClockOut = useCallback(() => {
    dispatch(editTimecard());
    updateAutoClockOut({
      id: shift.get('id'),
      status: 'updated',
      originPath: window.location.pathname,
    });
  }, [dispatch, updateAutoClockOut, shift]);

  const handleDismissAutoClockOut = useCallback(() => {
    updateAutoClockOut({
      id: shift.get('id'),
      status: 'dismissed',
      originPath: window.location.pathname,
    });
  }, [updateAutoClockOut, shift]);

  const options = [
    {
      label: toI18n('timecard_modal_v3.issues.auto_clock_out.resolve.cta'),
      color: 'navy',
      paddingLeft: 18,
      onClick: () => handleEditClockOut(),
    },
    {
      label: toI18n('actions.accept'),
      onClick: () => handleDismissAutoClockOut(),
      color: 'navy',
      paddingLeft: 18,
    },
  ];

  return <Issue issue={issue} options={options} />;
};

AutoClockOut.propTypes = {
  issue: ImmutablePropTypes.map.isRequired,
  updateAutoClockOut: PropTypes.func.isRequired,
};

export default connect(() => ({}), {
  updateAutoClockOut,
})(AutoClockOut);
